import { useEffect, useState } from "react";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";
import AuthService from "../../../../../api/AuthService";
import PurchaseSupplierList from "../../../../../entities/DashboardPage/AccountingModule/Supplier/PurchaseSupplierList";

const PurchaseOrderList = () => {
    const { showAlert } = useAlert();
    const [purchaseOrder, setPurchaseOrder] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.handleGetAllPurchaseOrder();            
            if (result?.success) {
                setPurchaseOrder(result?.data?.purchaseOrders);
                setTotal(result.data.total);
                LoaderHelper.loaderStatus(false);
            } else {
                showAlert(result.message, "error");
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {
            showAlert("Failed to load data", "error");
            LoaderHelper.loaderStatus(false);
        }
    };

    const handleDelete = async (id) => {
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.handleDeletePurchaseOrder(id);
            if (result?.success) {
                showAlert("Purchase Order Deleted", "success")
                fetchInitialData();
                LoaderHelper.loaderStatus(false);
            } else {
                showAlert(result.message, "error")
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {
            LoaderHelper.loaderStatus(false);
        }
    };

    return (
        <>
            <PurchaseSupplierList
                purchaseOrderData={purchaseOrder}
                total={total}
                setTotal={setTotal}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                handleDelete={handleDelete}
            />
        </>
    );
};

export default PurchaseOrderList;
